import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ApplicationState } from '@mews-commander/types';
import { getAvailabilityAdjustmentsUniqResourceCategoryIds } from '@mews-commander/legacy-entities/src/ducks/availabilityAdjustments';
import {
    getResourceCategoryTypesByServiceIds,
    getSortedResourceCategoryIds,
} from '@mews-commander/legacy-entities/src/ducks/resourceCategories';
import { ResourceCategoryEnumValue } from '../types';
import { getServicesResourceCategoryTypesByResourceCategoryIds } from './entities';
import { getSelectedAvailabilityBlockId } from './screens';

export const getResourceCategoryTypes = (
    state: ApplicationState,
    { serviceIds, scope }: { serviceIds: string[]; scope: string }
) => {
    const availabilityBlockId = getSelectedAvailabilityBlockId(state, { scope });
    return array.size(serviceIds) === 1
        ? pipe(
              serviceIds,
              array.head,
              option.map((serviceId) => {
                  const resourceCategoryIds = availabilityBlockId
                      ? getAvailabilityAdjustmentsUniqResourceCategoryIds(state, {
                            availabilityBlockId,
                        })
                      : getSortedResourceCategoryIds(state, { serviceId });

                  return getServicesResourceCategoryTypesByResourceCategoryIds(state, {
                      serviceId,
                      serviceIds,
                      ids: resourceCategoryIds,
                  }) as Array<ResourceCategoryEnumValue>;
              }),
              option.getOrElse((): Array<ResourceCategoryEnumValue> => [])
          )
        : (getResourceCategoryTypesByServiceIds(state, {
              serviceIds,
          }) as unknown as Array<ResourceCategoryEnumValue>);
};
